"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var analytics_subjects_1 = require("../../../../analytics-subjects");
var NoDataError_1 = require("../../../../components/NoDataError/NoDataError");
var copy_1 = require("../../copy");
var Loading_1 = require("./Loading");
var Error = function (_a) {
    var _b;
    var isFetching = _a.isFetching;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return isFetching ? (react_1.default.createElement(Loading_1.Loading, null)) : (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.METER_READS_INFO, properties: (_b = {
                status: 'error',
                reason: 'queryError'
            },
            _b[core_1.INTERNAL_EVENT_FLAG] = true,
            _b) },
        react_1.default.createElement(NoDataError_1.NoDataError, { heading: react_1.default.createElement(Copy, { copyKey: "meterReadsNoData" }), "data-testid": 'meter-reads-info-no-data' })));
};
exports.Error = Error;
